import styled from 'styled-components'

export const IndicatorFilter = styled.div`
  min-width: 220px;
  width: 220px;

  .indicator-filter-controls {
    display: flex;
    align-items: center;
    margin-bottom: 16px;

    .icon-button {
      height: 40px;
      width: 40px;
      font-size: 16px;
      border: 2px solid ${ (props) => props.theme.colors.grau2 };
      border-radius: 4px;

      &:disabled {
        svg {
          fill: ${ (props) => props.theme.colors.grau2 };
        }
      }

      &:first-child {
        margin-right: 24px;
      }

      &:last-child {
        margin-left: 24px;
      }

      svg {
        fill: ${ (props) => props.theme.colors['aok-gruen'] };
      }
    }
  }

  .indicator-filter-description {
    min-height: 50px;
    text-align: center;
  }
`
